import { AssetDistributionRejectionLog, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

export interface AssetDistributionQueryParams extends IqueryParams<{
  asset_id?: string;
  user_id?: string;
  user_email?: string;
  user_telephone?: string;
  asset_serial_number?: string;
  asset_embossment_number?: string;
  asset_brand?: string;
  distribution_batch_number?: string;
  from_location?: string;
  to_location?: string;
  reason?: string;
}> {}

interface ExportParams extends AssetDistributionQueryParams {
  file_format: 'pdf' | 'csv';
}

const getRejectedDistributions = async (queryParams?: AssetDistributionQueryParams) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetDistributionRejectionLog[]>(
    "get",
    `asset-distribution-rejections${query}`
  );
};

const getRejectedDistributionById = async (rejection_id: string) => {
  return apiService.apiRequest<AssetDistributionRejectionLog>(
    "get",
    `asset-distribution-rejections/${rejection_id}`
  );
};

const exportRejectedDistributions = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `asset-distribution-rejections/export${query}`
  );
};

export const distributionRejectionApi = {
  getRejectedDistributionById,
  getRejectedDistributions,
  exportRejectedDistributions,
};